// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2RVbD","description":"PatientConsentPreview_description__1EhN-"};